import type { ItemMiniEntity } from './ItemMiniEntity'

export class ItemResponseEntity {
  readonly remainingItems?: number
  count?: number
  readonly page?: number
  readonly limit?: number
  readonly metadata?: unknown
  items?: Array<ItemMiniEntity> | null
}
